import { Button, ButtonProps } from '@mui/material'

type Props = {
  isSelected?: boolean
} & ButtonProps

export const OverviewButton = ({
  isSelected,
  children,
  className = '',
  ...props
}: Props) => {
  return (
    <Button
      className={`
        w-full gap-1d
        text-3d font-semibold text-zBlack200
        ${className}
        `}
      sx={(theme) => ({
        background: isSelected ? theme.palette.custom.zGrey200 : 'transparent',
        '&:hover': {
          backgroundColor: isSelected
            ? theme.palette.custom.zGrey200
            : 'transparent',
        },
        '&:focus': {
          backgroundColor: isSelected
            ? theme.palette.custom.zGrey200
            : 'transparent',
        },
        '&:active': {
          backgroundColor: isSelected
            ? theme.palette.custom.zGrey200
            : 'transparent',
        },
      })}
      {...props}>
      {children}
    </Button>
  )
}
